import {
  AccessTimeOutlined,
  Accessibility,
  AccountBalanceOutlined,
  AccountCircle,
  Add,
  AddBox,
  AdjustOutlined,
  Alarm,
  Announcement,
  Apps,
  Archive,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowUpward,
  Assessment,
  AssessmentOutlined,
  Assignment,
  AssignmentOutlined,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  AttachFile,
  Block,
  BorderAll,
  Brush,
  CalendarTodayOutlined,
  CancelScheduleSend,
  ChangeCircleOutlined,
  Check,
  CheckBox,
  CheckCircle,
  CheckCircleOutlined,
  Circle,
  Close,
  CloseOutlined,
  Computer,
  DateRangeOutlined,
  Delete,
  DeleteOutlined,
  Description,
  DesktopMac,
  DnsOutlined,
  DoDisturbAlt,
  Edit,
  EnhancedEncryption,
  ErrorOutline,
  EventAvailable,
  EventBusy,
  ExpandLess,
  ExploreOutlined,
  Feedback,
  FileDownload,
  FilterList,
  Flag,
  FlagOutlined,
  FormatColorFill,
  Fullscreen,
  FullscreenExit,
  Group,
  HelpOutline,
  HelpOutlineOutlined,
  HistoryOutlined,
  ImportExport,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LensBlur,
  LibraryBooks,
  LibraryBooksOutlined,
  LineWeight,
  ListAlt,
  LocalLibrary,
  Lock,
  LockOutlined,
  Loop,
  MenuOutlined,
  Message,
  MicNoneOutlined,
  ModeCommentOutlined,
  ModeEdit,
  MoreVert,
  NearMe,
  NoteOutlined,
  Numbers,
  OpenInNew,
  PauseCircleOutlined,
  People,
  PlagiarismOutlined,
  PlayCircleOutlined,
  PlaylistRemove,
  Preview,
  PrintOutlined,
  Publish,
  QuizOutlined,
  RadioButtonChecked,
  Redo,
  Remove,
  RemoveRedEye,
  ReplyOutlined,
  RestartAlt,
  RuleOutlined,
  SaveOutlined,
  ScheduleSend,
  Search,
  SearchOff,
  SellOutlined,
  Send,
  SentimentDissatisfied,
  SettingsOutlined,
  SettingsSuggestOutlined,
  ShowChart,
  Shuffle,
  ShuffleOn,
  SignalCellularNodata,
  Sort,
  StopCircle,
  StopCircleOutlined,
  SwitchAccount, ThumbUp,
  ThumbUpOutlined,
  Timelapse,
  Timer,
  Unarchive,
  Undo,
  VerifiedUser,
  VideocamOutlined,
  VisibilityOff,
  Warning,
  ZoomIn,
  ZoomOut
} from "@mui/icons-material"

/**
 *
 * Gallery: https://material-ui.com/components/material-icons/
 *
 * API: https://material-ui.com/api/svg-icon/
 *
 */
export const MuiIcon = {
  AccessTimeOutlined,
  Accessibility,
  AccountBalanceOutlined,
  AccountCircle,
  Add,
  AddBox,
  AdjustOutlined,
  Alarm,
  Announcement,
  Apps,
  Archive,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowUpward,
  Assessment,
  AssessmentOutlined,
  Assignment,
  AssignmentOutlined,
  AssignmentTurnedIn,
  AssignmentTurnedInOutlined,
  AttachFile,
  Block,
  BorderAll,
  Brush,
  CalendarTodayOutlined,
  CancelScheduleSend,
  ChangeCircleOutlined,
  Check,
  CheckBox,
  CheckCircle,
  CheckCircleOutlined,
  Circle,
  Close,
  CloseOutlined,
  Computer,
  DateRangeOutlined,
  Delete,
  DeleteOutlined,
  Description,
  DesktopMac,
  DnsOutlined,
  DoDisturbAlt,
  Edit,
  EnhancedEncryption,
  ErrorOutline,
  EventAvailable,
  EventBusy,
  ExpandLess,
  ExploreOutlined,
  Feedback,
  FileDownload,
  FilterList,
  Flag,
  FlagOutlined,
  FormatColorFill,
  Fullscreen,
  FullscreenExit,
  Group,
  ListAlt,
  HelpOutline,
  HelpOutlineOutlined,
  HistoryOutlined,
  ImportExport,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LensBlur,
  LibraryBooks,
  LibraryBooksOutlined,
  LineWeight,
  Lock,
  LocalLibrary,
  LockOutlined,
  Loop,
  MenuOutlined,
  Message,
  MicNoneOutlined,
  ModeCommentOutlined,
  ModeEdit,
  MoreVert,
  NearMe,
  NoteOutlined,
  Numbers,
  OpenInNew,
  PauseCircleOutlined,
  People,
  PlagiarismOutlined,
  PlayCircleOutlined,
  PlaylistRemove,
  Preview,
  PrintOutlined,
  Publish,
  QuizOutlined,
  RadioButtonChecked,
  Redo,
  Remove,
  RemoveRedEye,
  ReplyOutlined,
  RestartAlt,
  RuleOutlined,
  SaveOutlined,
  ScheduleSend,
  Search,
  SearchOff,
  SellOutlined,
  Send,
  SentimentDissatisfied,
  SettingsOutlined,
  SettingsSuggestOutlined,
  ShowChart,
  Shuffle,
  ShuffleOn,
  SignalCellularNodata,
  Sort,
  StopCircle,
  StopCircleOutlined,
  SwitchAccount,
  Timelapse,
  Timer,
  ThumbUpOutlined,
  ThumbUp,
  Unarchive,
  Undo,
  VerifiedUser,
  VideocamOutlined,
  VisibilityOff,
  Warning,
  ZoomIn,
  ZoomOut
}


